;
var SelectOption = function SelectOption() {
  return null;
};
SelectOption.isSelectOption = true;
export default SelectOption;